import { lazy } from 'react';

export const Groups = lazy(() => import('./ui/Groups'));
